<template>
  <div>
    <Modal v-model="reNameModal" title="重命名视图" @on-cancel="newName = ''; oldName = ''">
      <Alert show-icon>正在重命名视图「{{ oldName }}」</Alert>
      新视图名：<Input v-model="newName" placeholder="请输入新的视图名称" />
      <div slot="footer">
        <Button type="primary" @click="reNameOk" :loading="reNaming">提交</Button>
        <Button @click="reNameModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Row>
      <div v-for="(item, index) in data" :key="index" style="padding-left: 10px; display:block; width: 350px; float: left; line-height: 25px;">
        <Dropdown trigger="contextMenu" @on-click="v=>{ clickTools(v, item)}" transfer :class="{'table-list-item': true, 'table-list-item-active': item === selectView}">
          <span v-on:dblclick="openView(item)" v-on:click="select(item)">
            <span><font-awesome-icon icon="glasses" style="color: #2d8cf0" /></span>
            <span style="padding-left: 5px">{{ item }}</span>
          </span>
          <DropdownMenu slot="list">
            <DropdownItem name="create">新建视图</DropdownItem>
            <DropdownItem name="open">打开视图</DropdownItem>
            <DropdownItem name="modifyView">编辑视图</DropdownItem>
            <DropdownItem name="reName" :disabled="reNaming">重命名</DropdownItem>
            <DropdownItem name="delete" :style="{ color: deleting ? '' : 'red' }" :disabled="deleting">删除视图</DropdownItem>
            <DropdownItem name="refresh">刷新</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Row>
    <Row style="margin-top: 30px">
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Row>
  </div>
</template>

<script>
import { showViewList, executeSQL } from '@/api/mysql'
import SQLResults from './sqlResults'
export default {
  name: 'dbViewList',
  components: {
    SQLResults
  },
  data () {
    return {
      data: [],
      getDataIng: false,
      selectView: '',
      deleting: false,
      // 重命名
      reNameModal: false,
      oldName: '',
      newName: '',
      reNaming: false
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    this.getListData()
  },
  methods: {
    getListData () {
      this.getDataIng = true
      let params = {
        db: this.callbackdata.db,
        id: this.callbackdata.instance_id
      }
      showViewList(params).then(res => {
        this.getDataIng = false
        this.selectView = ''
        this.data = res.data.results
      }).catch(res => {
        this.getDataIng = false
      })
    },
    // 打开视图
    openView (name) {
      let data = {
        viewName: name,
        db: this.callbackdata.db
      }
      this.$emit('callBack', 'openView', data)
    },
    // 编辑视图
    modifyView (name) {
      let data = {
        viewName: name,
        db: this.callbackdata.db
      }
      this.$emit('callBack', 'modifyView', data)
    },
    // 右键触发下拉工具
    clickTools (type, name) {
      switch (type) {
        case 'create':
          this.$emit('callBack', 'createView', this.callbackdata)
          break
        case 'open':
          this.openView(name)
          break
        case 'delete':
          this.deleteView(name)
          break
        case 'reName':
          this.openReNameModal(name)
          break
        case 'modifyView':
          this.modifyView(name)
          break
        case 'refresh':
          this.getListData()
          break
      }
    },
    // 选中/取消选中 表
    select (name) {
      if (this.selectView === name) {
        this.selectView = ''
      } else {
        this.selectView = name
      }
    },
    // 打开重命名模态框
    openReNameModal (name) {
      this.oldName = name
      this.reNameModal = true
    },
    // 重命名表
    reNameOk () {
      if (!this.newName) {
        this.$Notice.error({
          title: '视图名不能为空'
        })
        return false
      }
      let sql = 'RENAME TABLE ' + this.oldName + ' TO ' + this.newName + ';'
      this.reNaming = true
      this.execSQLAction(sql, 'reName')
    },
    // 删除表
    deleteView (name) {
      if (this.deleting) {
        return false
      }
      this.$Modal.confirm({
        title: '确认删除视图「' + name + '」吗？',
        onOk: () => {
          this.deleting = true
          let sql = 'DROP VIEW ' + name + ';'
          this.execSQLAction(sql, 'delete')
        }
      })
    },
    // 执行SQL动作
    execSQLAction (sql, type) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: 100
      }
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        this.$refs.SQLResults.showResult(results)
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getListData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.reNameModal = false
            this.newName = ''
            this.getListData(this.callbackdata)
          }
        }
      }).catch(res => {
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getListData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.getListData(this.callbackdata)
          }
        }
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .table-list-item-active {
    background-color: rgb(243, 243, 243);
    color: #2d8cf0;
  }
  .table-list-item:hover, .table-list-item:visited {
    color: #2d8cf0;
    cursor:pointer;
  }
</style>
